module.exports = __webpack_public_path__ + "static/media/02_JanineWestphal_webfinal.bf8d8945.jpg";